<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <div class="col-12">
                  <ValidationProvider name="student_program_id" rules="required" v-slot="{ valid, errors }">
                    <b-form-group :label="$t('student')">
                      <StudentsAutoComplete
                          :value="selectedPresident"
                          @user-input="handleSelection"
                          student-type="mentora"  :validate-error="errors[0]"/>
                    </b-form-group>
                  </ValidationProvider>
                </div>
                <div class="col-12">
                    <ValidationProvider name="module_date_id" rules="required" v-slot="{ valid, errors }">
                      <b-form-group :label="$t('module_date')">
                        <module-date-selectbox ref="moduleDate" v-model="form.module_date_id" :validate-error="errors[0]">
                        </module-date-selectbox>
                      </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12">
                    <ValidationProvider name="status" rules="" v-slot="{ valid, errors }">
                      <b-form-group :label="$t('status')">
                        <parameter-selectbox code="student_module_statuses" v-model="form.status" :validate-error="errors[0]"></parameter-selectbox>
                      </b-form-group>
                    </ValidationProvider>
                </div>

            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button @click="createForm" type="button" variant="primary" class="btn-lg mr-2">
                {{ $t('save').toUpperCase() }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import ModuleDateSelectbox from "@/components/interactive-fields/ModuleDateSelectbox.vue";
    import EslStudentModuleServices from "@/services/EslStudentModuleServices";
    import StudentsAutoComplete from "@/components/interactive-fields/StudentsAutoComplete.vue";

    export default {
        components: {
          StudentsAutoComplete,
          ModuleDateSelectbox,
            ValidationProvider, ValidationObserver,
        },
        data() {
            return {
                formLoading: false,
               selectedPresident:'',
                form: {
                  student_program_id: null,
                  module_date_id: null,
                  status: null,
                }
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.formLoading = true;
                    EslStudentModuleServices.store(this.form)
                               .then((response) => {
                                   this.$toast.success(this.$t("api." + response.data.message));
                                   this.$emit("createFormSuccess")
                               })
                               .catch((error) => {
                                   this.showErrors(error, this.$refs.formModalValidate)
                               }).finally(() => {
                        this.formLoading = false;
                    });
                }
            },
          handleSelection(user) {
            this.form.student_program_id = user?.student_program_id;
            this.selectedPresident = user ? `${user.name} ${user.surname}` : '';
          },
        }
    }
</script>
